import { Component } from "@angular/core";
import { ObbligoProvider } from "src/app/services/obbligo.provider";

@Component({
  selector: "app-obbligo",
  templateUrl: "./obbligo.component.html",
  styleUrls: ["./obbligo.component.scss"],
})
export class ObbligoComponent {
  data!: any | undefined;

  obbligoDetails$ = this._obbligoProvider.obbligoDetails$;

  constructor(private _obbligoProvider: ObbligoProvider) { }
}
